import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const VEHICLE_BUY_IN_RESOURCE = "vehicle-buy-in" as const;
export const VEHICLE_BUY_IN_CREATE_DATA_API_PATH = "/v1/vehicle-buy-in/create-data" as const;

export type VehicleBuyInCreateDataParameters =
  paths[typeof VEHICLE_BUY_IN_CREATE_DATA_API_PATH]["get"]["parameters"]["query"];
export type VehicleBuyInCreateDataResponse =
  paths[typeof VEHICLE_BUY_IN_CREATE_DATA_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleBuyInCreateDataQuery(vehicleValuationUuid: string) {
  return useQuery({
    queryKey: [VEHICLE_BUY_IN_RESOURCE, "create-data", vehicleValuationUuid],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<VehicleBuyInCreateDataResponse>(
        VEHICLE_BUY_IN_CREATE_DATA_API_PATH,
        { params: { vehicleValuationUuid } satisfies VehicleBuyInCreateDataParameters },
      );
      return response.data;
    },
    enabled: Boolean(vehicleValuationUuid),
  });
}
